<template>
  <!-- prettier-ignore -->
  <div class="debug">
      <!-- :class="{ 'is-loading': loading$.getState().active }" -->
    <button
      class="debug__btn"
      :class="{ 'is-loading': loading$.getState().active.value === true }"
      @click="isOpen = true"
    >🐼</button>
    <span
      v-if="elapsedTimeSession"
      href=""
      class="debug__session" 
    >
      <the-icon 
        ref="debugSessionRef" 
        name="stopwatch" 
        art="regular"
      />
      {{ elapsedTimeSession }}
    </span>

    <the-form-modal
      v-model="isOpen"
      open
    >
      <Modal.Header text="Debug Menu"/>
      <Modal.Content>
        <h2>export</h2>

        <div>
          <h3>debug data</h3>
          <p>to be on the safe(er) side of things, we will overwrite mobile/email with your own, when we export a basket. <br><strong style="color:red">These two fields have to read your own email/mobile!</strong> </p>
          <div>
            <div>
              <label>
                email
                <input
                  v-model="debugData.email"
                  :placeholder="basket.email" 
                />
              </label>
            </div>

            <div>
              <label>
                mobile
                <input
                  v-model="debugData.mobile"
                  :placeholder="basket.mobile"
                />
              </label>
            </div>
            
            <button @click="saveDebugData">save</button>
          </div>
        </div>

        <div class="debug__sections">

          <div class="debug__section">
            <h2>session</h2>
            <ul>
              <li><a @click="clearBasket">clear basket</a></li>
              <li>
                <a @click="sections.basket = !sections.basket">import basket</a>
                <form
                  v-if="sections.basket"
                  @submit.prevent="importBasket">
                  <label>
                    <input
                      id="basket-input"
                      required
                      type="text"
                      name="data"
                      placeholder="put basket here!"
                      autofocus
                    />

                    <button type="submit">🗲</button>
                  </label>

                  <label>
                    <input
                      type="checkbox"
                      name="randomize"
                      @click="sections.bRandomize = !sections.bRandomize">
                    randomize
                  </label>

                  <template v-if="sections.bRandomize">
                    <label><input
                      type="checkbox"
                      value="true"
                      name="nameRandomized" /> randomize name</label>
                    <label><input
                      type="checkbox"
                      value="true"
                      name="dobRandomized" /> randomize date of birth</label>
                    <label><input
                      type="checkbox"
                      value="true"
                      name="genderRandomized" /> randomize gender</label>
                    <label><input
                      type="checkbox"
                      value="true"
                      name="addressRandomized"> randomize address</label>
                  </template>

                </form>
              </li>
              <li>
                <button
                  :disabled="!debugData.mobile || !debugData.email"
                  @click="exportBasket(true)">
                  export basket anonymized
                </button>
                or
                <button
                  @click="exportBasket(false)">
                  export basket as-is
                </button>
              </li>
            </ul>
          </div>

          <div class="debug__section">
            <h2>basket</h2>
            <ul style="font-size:10px">
              <li>basketId: {{ basket.basketId }}</li>
              <li>channel: {{ basket.channel }}</li>
              <li>contractStartDate: {{ basket.contractStartDate }}</li>
              <li>masterTreaty: {{ basket.masterTreaty }}</li>
              <li>reentryToken: {{ basket.reentryToken }}</li>
              <li>existingCustomer: {{ basket.existingCustomer }}</li>
              <li>distributionPartners: <pre>{{ basket.distributionPartners }}</pre></li>
            </ul>
          </div>

          <div class="debug__section">
            <h2>person</h2>
            <ul>
              <li><a @click="showProductIds">show product id</a></li>
            </ul>
          </div>

          <div class="debug__section">
            <h2>partner/collective/advisory protocol</h2>
            <ul>
              <li><a @click="promptReEntry">start reentry</a></li>
              <li><a @click="promptPartner">start partner/collective</a></li>

              <ul>
                <li><a @click="promptPartner('K003000')">Collective Credit Suisse (K003000)</a></li>

                <li><a @click="promptPartner('346448')">Smile Partner (346448)</a></li>
                <li><a @click="promptPartner('317826')">Allianz Private Insurer (317826)</a></li>
                <li><a @click="promptPartner('353527')">Mobile Distribution (FLEX-493) (353527)</a></li>
              </ul>

              <li>Advisory Protocol (Brokers Maklerzentrum)</li>
              <ul>
                <li><a @click="promptPartner('346153')">Broker (DEV only, Toni's Mail) (346153)</a></li>
                <li><a @click="promptPartner('337636')">Broker (Maklerzentrum RV Berater) (337636)</a></li>
                <li><a @click="promptPartner('337981')">Broker (Maklerzentrum RV Leiter) (337981)</a></li>
                <li><a @click="promptPartner('337977')">Broker (Maklerzentrum Backoffice) (337977)</a></li>
              </ul>
              <li><a @click="createAdvisoryProtocol">Create advisory protocol</a></li>
              <li><a @click="deleteAdvisoryProtocol">Delete advisory protocol</a></li>
            </ul>
          </div>

          <div class="debug__section">
            <h2>validation</h2>
            <ul>
              <li><a @click="showConditions">show conditions</a></li>
              <li><a
                :disabled="!assessmentEnabled"
                @click="getRiskAssesment">get risk-assesment</a></li>
            </ul>
          </div>

          <div class="debug__section">
            <h2>various (dev/debug)</h2>
            <ul>
              <li><a
                @click="changeOnboardingData">Change onboarding data via persistBasket (no BE call)
              </a></li>
            </ul>
          </div>

        </div>
      </Modal.Content>
    </the-form-modal>
  </div>
</template>

<script setup>
import { computed, nextTick, onMounted, reactive, ref } from 'vue'
import { v4 as uuidv4 } from 'uuid'

import { loading$ } from '@/services'

import * as Modal from '@/components/Modal'

import { useAuth, useBasket, useMasterdata, useOvp, useStatus } from '@/hooks'
import { SESSION_UPDATED_KEY } from '@/config/constants'

import { ReactivityUtil } from '@/utils/Reactivity'

// Hooks
const { basket, persistBasket } = useBasket()
const { getRiskAssessment } = useOvp()

// DATA
const isOpen = ref(false)
const elapsedTimeSession = ref(0)
const sections = reactive({})
const debugData = reactive({
  mobile: null,
  email: null,
})
const DEBUG_OPTION_KEY = 'sanitas-dvp-debug'
const debugSessionRef = ref(null)

// COMPUTED
const assessmentEnabled = computed(() => {
  const { routeStates } = useStatus()
  const { isOfferComplete } = routeStates

  return isOfferComplete
})

// METHODS
function changeOnboardingData() {
  persistBasket({
    ...basket,
    mobile: '+41792781234',
    email: 'debug@actions.ch',
  })
}

function clearBasket() {
  const { restartApplication } = useAuth()

  restartApplication()
}

async function exportBasket(anonymize) {
  let __basket = ReactivityUtil.clone(basket)

  if (debugData.email) __basket.email = debugData.email
  if (debugData.mobile) __basket.mobile = debugData.mobile

  if (anonymize) {
    const randomized = {
      address: true,
      dateOfBirth: false,
      gender: false,
      name: true,
    }
    __basket = await prepareData(__basket, randomized)
  }

  const payload = JSON.stringify(__basket)
  navigator.clipboard
    .writeText(payload)
    .then(
      () => {
        alert('basket copied to clipboard!')
      },
      () => {
        alert('error while writing to clipboard!')
      }
    )
    .catch(console.error)
}

async function transformPerson(person, existingUsers, randomized) {
  if (randomized.dateOfBirth || randomized.name || randomized.gender) {
    const gender = randomized.gender ? '' : person.personData.gender
    const random = await getRandomizedUser(gender)

    if (randomized.name) {
      person.personData.firstName = random.name.first
      person.personData.lastName = random.name.last
    }

    if (randomized.dateOfBirth) {
      person.personData.dateOfBirth = random.dob.date.substring(0, 10)
    }

    if (randomized.gender) {
      person.personData.gender = random.gender.toUpperCase()
    }
  }

  person.personId = existingUsers[person.personId] = uuidv4()
  person.healthQuestionAnswers.forEach(question => delete question.id)

  delete person.oaOfferId
  delete person.oaPersonId

  return person
}

async function prepareData(payload, randomized) {
  const keys = ['basketId', 'jwToken', 'reentryToken', 'oaBasketId', 'submitted']
  keys.forEach(key => {
    delete payload[key]
  })

  const existingUsers = {}
  await Promise.all(payload.persons.map(async p => await transformPerson(p, existingUsers, randomized)))
  // use newly generated id from person; for existingCustomer-imports
  if (payload.contractOwner?.contractOwnerType === 'PERSONID') {
    if (existingUsers[payload.contractOwner.personId]) {
      payload.contractOwner.personId = existingUsers[payload.contractOwner.personId]
    } else {
      console.warn('FALLBACK-MODE FOR DEBUG-ACTION! correct contractOwner personId seems to be missing')
      payload.contractOwner.personId = Object.entries(existingUsers)[0][1]
    }
  }

  if (randomized.address) {
    payload.address = await getRandomizedLocation(payload.contractStartDate)
  }

  return payload
}

async function importBasket(event) {
  loading$.start()
  const { createOvpBasket, updateOvpBasket } = useBasket()

  let payload
  const data = new FormData(event.target)

  try {
    payload = JSON.parse(data.get('data'))
  } catch (error) {
    alert('error parsing basket!')
    return
  }

  const randomized = {
    address: data.get('addressRandomized'),
    dateOfBirth: data.get('dobRandomized'),
    gender: data.get('genderRandomized'),
    name: data.get('nameRandomized'),
  }

  const delay = payload.persons.length

  payload = await prepareData(payload, randomized)

  try {
    await createOvpBasket(payload)
    /*
       Create-Basket call is not calling risk-assessment-ms, so no healthQuestions are stored via this call
       Therefore, if there are healthQuestions for at least one person, we need to call Update-Basket to get the
       answers to the healthQuestions as well
    */
    if (payload.persons.some(p => p.healthQuestionAnswers.length > 0)) {
      await updateOvpBasket({ persons: payload.persons })
    }
    setTimeout(() => window.location.reload(), delay)
  } catch (error) {
    loading$.failed()
    console.error(error)
    alert('Something went wrong, contact the SALES-Squad')
  }
}

async function getRandomizedUser(gender = '') {
  const country = 'ch'
  const fields = 'gender,name,email,location,dob'
  let results = await fetch(`https://randomuser.me/api/?nat=${country}&gender=${gender}&inc=${fields}&noinfo`)

  results = await results.json()

  return results.results[0]
}

async function getRandomizedLocation(contractStartDate) {
  const { fetchLocations } = useMasterdata()

  const random = await getRandomizedUser()
  let location = await fetchLocations({
    query: random.location.postcode.toString(),
    contractStartDate,
  })
  location = location.data

  if (location.length > 0) {
    return Object.assign({}, location[0], {
      street: random.location.street.name,
      houseNumber: random.location.street.number,
    })
  } else {
    return getRandomizedLocation(contractStartDate)
  }
}

function showProductIds() {
  document.querySelectorAll('[data-product-id]').forEach(node => {
    const span = document.createElement('span')
    const textNode = document.createTextNode(node?.dataset?.productId)
    span.setAttribute(
      'style',
      'position:absolute;top:-10px;right:0;padding:4px;background:lightyellow;border:1px dashed;font-size:10px;'
    )
    node.style.position = 'relative'
    span.appendChild(textNode)
    node.appendChild(span)
  })
}

async function promptReEntry() {
  let token = prompt('enter token', basket.reentryToken)
  if (token) {
    token = token.trim()
    const url = window.location.href.replace(/(\/?#).*/, `$1/${token}`)
    isOpen.value = false

    await nextTick()

    window.onbeforeunload = null
    window.open(url, '_self')
  }
}

async function promptPartner(partnerNumber) {
  let number = typeof partnerNumber === 'string' ? partnerNumber : prompt('Enter Collective- or Partner-Number')

  if (number) {
    number = number.trim()
    let url = window.location.href.replace(/(\/?#).*/, `$1/${number}`)

    if (number[0] !== 'K') {
      url = window.location.href.replace(/(\/?#).*/, `$1/partner/${number}`)
    }

    isOpen.value = false

    await nextTick()

    window.onbeforeunload = null
    window.open(url, '_self')
  }
}

async function getRiskAssesment() {
  try {
    const assessment = await getRiskAssessment(basket)
    const pretty = syntaxHighlight(JSON.stringify(assessment, null, 2))

    const w = window.open()
    w.document.writeln(
      `<head><style>pre {outline: 1px solid #ccc; padding: 5px; margin: 5px; } .string { color: green; }.number { color: darkorange; } .boolean { color: blue; } .null { color: magenta; } .key { color: red; }</style></head><body><pre>${pretty}</pre>`
    )
  } catch (error) {
    alert('ah maaaaan! getting the assessment failed, talk to thilo.')
    console.error(error)
  }
}

function saveDebugData() {
  localStorage.setItem(DEBUG_OPTION_KEY, JSON.stringify(debugData))
}

function startSessionTimer() {
  const { isOnboardingSecured } = useStatus()
  setInterval(() => {
    const sessionUpdated = parseInt(window.sessionStorage.getItem(SESSION_UPDATED_KEY), 10)
    if (!isOnboardingSecured.value || !sessionUpdated) {
      elapsedTimeSession.value = null
      return
    }
    const now = new Date().getTime()
    const msElapsed = now - sessionUpdated
    const secondsElapsed = msElapsed / 1000
    const mins = Math.round(secondsElapsed / 60)
    const secs = Math.round(secondsElapsed % 60)
    const percentage = msElapsed / import.meta.env.VITE_SESSION_AUTH
    if (debugSessionRef.value) {
      debugSessionRef.value.$el.style.transform = `rotate(${Math.round(percentage * 360)}deg)`
      if (percentage > 0.95) {
        debugSessionRef.value.$el.classList.add('fa-beat')
      } else {
        debugSessionRef.value.$el.classList.remove('fa-beat')
      }
    }
    elapsedTimeSession.value = `${mins}:${secs < 10 ? '0' : ''}${secs}`
  }, 1000)
}

function syntaxHighlight(json) {
  if (typeof json != 'string') {
    json = JSON.stringify(json, undefined, 2)
  }
  json = json.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;')
  return json.replace(
    /("(\\u[a-zA-Z0-9]{4}|\\[^u]|[^\\"])*"(\s*:)?|\b(true|false|null)\b|-?\d+(?:\.\d*)?(?:[eE][+-]?\d+)?)/g,
    function (match) {
      var cls = 'number'
      if (/^"/.test(match)) {
        if (/:$/.test(match)) {
          cls = 'key'
        } else {
          cls = 'string'
        }
      } else if (/true|false/.test(match)) {
        cls = 'boolean'
      } else if (/null/.test(match)) {
        cls = 'null'
      }
      return '<span class="' + cls + '">' + match + '</span>'
    }
  )
}

onMounted(() => {
  try {
    startSessionTimer()
    const data = JSON.parse(localStorage.getItem(DEBUG_OPTION_KEY))

    debugData.mobile = data.mobile
    debugData.email = data.email
  } catch {
    /*noop*/
  }
})
</script>

<style name="mobile" scoped>
.debug {
  &__btn {
    position: relative;
    font-size: 20px;
    background-color: transparent;
    border: none;
    cursor: pointer;

    &:after {
      position: absolute;
      content: ' ';
      height: 5px;
      width: 8px;
      top: 5px;
      left: calc(50% - 4px);
      background-color: transparent;
      z-index: -1;

      transition: background-color 0.2s ease-in-out;
    }

    &.is-loading:after {
      background-color: red;
    }
  }

  &__sections {
    display: grid;
    grid-template-columns: 50% 50%;
  }

  &__section {
    form {
      display: flex;
      flex-direction: column;
    }
  }
}
.debug__session {
  display: flex;
  align-items: center;
  gap: 4px;
  line-height: 100%;
}
</style>
